import { bool, func, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { WorkTypeValueState } from "@repo/utils";
import { InfoLabel, TextField } from "@components";
import { Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

export const CellFormatSelect = ({
  value,
  disabled,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      item container
      alignItems="center"
      wrap="nowrap"
      justifyContent="space-between"
      spacing={1}
      className="mb-4"
    >
      <Grid item>
        <InfoLabel label={t("views.editor.cell_settings.format")} spacing={0} />
      </Grid>
      <Grid item>
        <Autocomplete
          id="cellFormatSelect"
          value={value}
          size="small"
          disabled={disabled}
          onChange={onChange}
          getOptionSelected={(o, v) => o === v}
          getOptionLabel={(o) => t("cell_mode." + o)}
          disableClearable
          options={[ WorkTypeValueState.SINGLE, WorkTypeValueState.MIN_MAX ]}
          renderInput={(params) => (
            <TextField {...params} label="" className="mb-0 w-256" />
          )}
        />
      </Grid>
    </Grid>
  );
};

CellFormatSelect.propTypes = {
  value: string,
  disabled: bool,
  onChange: func.isRequired,
};
